import { PossibleNodeTypes } from './types';

export const convertToString = (value: PossibleNodeTypes) =>
  value === null ? 'null' : value.toString();
